import styled from 'styled-components';
import Fab from '@mui/material/Fab';
import { makeStyles } from '@mui/styles';
// import IconButton from '@material-ui/core/IconButton';

export const VideoContainer = styled.div`
  display: flex;
  padding: 1rem;
  /* min-height:   ${({ fullWidth }) => (fullWidth ? 'initial' : '250px')}; */
  position: relative;
  /* ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : `margin-right: -50px;`)} */
  width: 100%;
`;

export const CloseBtn = styled(Fab)`
  right: 50px;
  top: 10px;
  /* position: absolute; */
  /* height: 33px;
  && {
    background: white;
  } */
`;

export const useClasses = makeStyles((theme) => ({
  video: {
    [theme.breakpoints.down('xs')]: {
      width: '250px',
      height: '175px',
    },
  },
}));
